<div class="card-group" id="accordion" role="tablist" aria-multiselectable="true">
  <div class="card card-default" style="margin-bottom: 0; margin-top: 15px; border: none">
    <div class="editor-informacoes" [formGroup]="formProduct" style="border: none; padding: unset">
      <div class="card-header" role="tab" id="headingOne">
        <h4 class="card-title">
          Produtos
          <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true"
            aria-controls="collapseOne">
            <i class="fas fa-caret-down"></i>
          </a>
        </h4>
      </div>
      <div id="collapseOne" class="card-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
        <div class="card-body">
          <div class="row linha-editor">
            <div class="col-lg-3">
              <label>Tabela</label><br />
              <div class="input-group">
                <ng-select id="table" formControlName="table" style="width: 100%" [placeholder]="'Tabela'"
                  (change)="onChangeTable($event)">
                  <ng-option *ngFor="let item of tables | keyvalue" [value]="item.key">
                    {{item.value}}
                  </ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-lg-3">
              <label>Versão</label><br />
              <div class="input-group">
                <ng-select id="table_version" formControlName="table_version" style="width: 100%" [placeholder]="
                loadingVersion
                  ? 'Carregando versões. Aguarde, por favor.'
                  : 'Selecione uma versão'
              " (change)="onChangeTableVersion($event)">
                  <ng-option *ngFor="let item of tableVersions" [value]="item.version">
                    {{item.version}}
                  </ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-lg-5">
              <label>Produto</label><br />
              <div class="input-group">
                <ng-select id="produto" formControlName="product" style="width: 100%" [placeholder]="
                    loadingProducts
                      ? 'Carregando Produtos. Aguarde, por favor.'
                      : 'Selecione um Produto'
                  " (change)="selectProduct()">
                  <ng-option *ngFor="let dir of products" [value]="dir">
                    <span class="d-flex align-items-center">
                      {{
                      dir?.ml_products_table_versions_prices?.product
                      ?.description
                      }}
                      {{
                      dir?.ml_products_table_versions_prices?.product
                      ? dir?.ml_products_table_versions_prices?.product
                      ?.content
                      : ''
                      }}
                      <ng-template [ngIf]="isProductWithClientRule(dir.id)">
                        <span class="text-primary ml-1" style="font-size: 12px">(Regra de Cliente)</span>
                      </ng-template>
                    </span>
                  </ng-option>
                </ng-select>
                <div class="col-lg-12 mt-2" style="display: flex;place-content: end;">
                  <!-- <div> -->
                  <div>
                    <label>Preço de Custo</label>
                    <div class="input-group" style="place-content: center;">
                      <mat-slide-toggle class="example-margin" formControlName="isPriceCost"></mat-slide-toggle>
                    </div>
                  </div>
                  <!-- </div> -->
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <label>Quantidade</label>
              <br />
              <div class="input-group">
                <input type="number" class="form-control" formControlName="quantity" name="quantity" />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <div class="form-group" id="deflator" *ngIf="deflatorVisible">
                  <label for="validate-text">Deflator</label>
                  <div class="input-group">
                    <input type="text" class="form-control" formControlName="valueNegative" mask="9*" suffix=" %" />
                  </div>
                </div>
              </div>
              <div>
                <div class="form-group" id="inflator" *ngIf="inflatorVisible">
                  <label for="desvalorizacao"> Inflator </label>
                  <div class="input-group">
                    <input type="text" class="form-control" formControlName="valuePositive" mask="9*" suffix=" %" />
                  </div>
                </div>
              </div>
              <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                [(ngModel)]="isDisabledNegative" [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="inputControl(isDisabledNegative)" style="display: inline-flex; margin-left: 2px;">
                <mat-radio-button class="example-radio-button" [value]="true" style="margin-right: 1rem">
                  Deflator
                </mat-radio-button>
                <mat-radio-button class="example-radio-button" [value]="false">
                  Inflator
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <p>
                <strong>Preço Produto: </strong>
                {{
                formProduct.value.product
                ? (formProduct.value.priceProduct | currency: 'BRL')
                : 'R$ 00,00'
                }}
              </p>
              <p>

                <strong> Total: </strong>
                {{
                formProduct.value.end_price
                ? (formProduct.value.end_price | currency: 'BRL')
                : 'R$ 00,00'
                }}
              </p>
            </div>
          </div>

          <div class="row" *ngIf="formType == 'BUDGET'">
            <div class="col-lg-3">
              <div class="notice notice-success">
                <p>
                  <strong>Subtotal: </strong><span>{{
                    formProduct.value.subtotal | currency: 'BRL'
                    }}</span>
                </p>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="notice notice-success">
                <p>
                  <strong>Custo Subtotal: </strong><span>{{
                    formProduct.value.subtotal_cost | currency: 'BRL'
                    }}</span>
                </p>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="notice notice-success">
                <p>
                  <strong>Custo Mensal: </strong><span>{{
                    formProduct.value.monthly_cost_value | currency: 'BRL'
                    }}</span>
                </p>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="notice notice-success">
                <p>
                  <strong>Lucro Mensal: </strong><span>{{
                    formProduct.value.monthly_result_value | currency: 'BRL'
                    }}</span>
                </p>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="notice notice-success">
                <p>
                  <strong>Valor Mensal: </strong><span>{{
                    formProduct.value.monthly_result_value | currency: 'BRL'
                    }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-2">
              <button type="button" class="btn btn-primary" (click)="addProduct()" style="margin: 25px 0"
                [disabled]="!formProduct.valid">
                Adicionar
              </button>
            </div>
          </div>
          <div class="row linha-editor">
            <div class="col-lg-12">
              <div class="table-responsive-vertical">
                <div class="d-flex justify-content-end" *ngIf="formType == 'BUDGET'">
                  <button type="button" class="btn text-primary d-flex align-items-center justify-content-center"
                    matTooltip="Atualizar Valores" (click)="updateProductValues()">
                    <mat-icon>sync</mat-icon>
                    <span class="lh-sm ml-1">Atualizar Valores dos Produtos</span>
                  </button>
                </div>
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Quant.</th>
                      <th>Inflator</th>
                      <th>Deflator</th>
                      <th>Preço Final</th>
                      <th style="width: 15%">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                        let item of ml_package_products_list;
                        let i = index
                      ">
                      <td data-title="Descrição">
                        {{
                        item?.product?.ml_products_table_versions_prices
                        ?.product
                        ? item?.product?.ml_products_table_versions_prices
                        ?.product?.description
                        : (item?.ml_products_company
                        ?.ml_products_table_versions_prices?.product
                        ?.description | titlecase)
                        }}
                        <span class="identify" [ngStyle]="{
                            display:
                            item.package_description ||
                            item.ml_package
                                ? 'block'
                                : 'none'
                          }">
                          <span class="material-icons" *ngIf="
                              item.package_description != '' ||
                              item.package_description != null ||
                              item.ml_package
                            " style="font-size: 20px; color: #50a592">
                            inventory_2
                          </span>
                          -
                          {{
                          item?.package_description
                          ? (item?.package_description | titlecase)
                          : (item?.ml_package?.description | titlecase)
                          }}</span>
                        <span class="material-icons" *ngIf="item?.product?.kit || item?.ml_products_company?.kit"
                          style="font-size: large;color: #cd6532;" (click)="openDialogViewKit(item?.product ? item?.product?.kit : item?.ml_products_company?.kit)">
                          medical_services
                        </span>
                      </td>
                      <td data-title="Quant">
                        {{ item.package_custom == true || item.quantity_custom != null ? item.quantity_custom :
                        item?.quantity }}
                      </td>
                      <td data-title="Quant">
                        {{
                        item?.inflator != ''
                        ? (item?.inflator | percent)
                        : '-'
                        }}
                      </td>
                      <td data-title="Quant">
                        {{
                        item?.deflator != ''
                        ? (item?.deflator | percent)
                        : '-'
                        }}
                      </td>
                      <td data-title="Quant">
                        {{
                        item.package_id || item.package_custom ? 'R$ 0,00' :
                        item?.end_price != ''
                        ? (item?.end_price | currency: 'BRL')
                        : 'R$ 00,00'
                        }}
                      </td>
                      <td data-title="Ações" *ngIf="formType == 'PACKAGE'">
                        <a href="javascript:void(0)" (click)="deleteProduct(item)" matTooltip="Apagar item">
                          <mat-icon aria-hidden="true" style="color: #d9534f" aria-label="Example home icon">
                            close
                          </mat-icon>
                        </a>
                      </td>
                      <td data-title="Ações" *ngIf="formType == 'BUDGET'">
                        <a href="javascript:void(0)" (click)="deleteProduct(item)" matTooltip="Apagar item"
                          [ngStyle]="{display: item.package_id || item.ml_package_custom_id ? 'none' : 'block'}">
                          <mat-icon aria-hidden="true" style="color: #d9534f" aria-label="Example home icon">
                            close
                          </mat-icon>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <mat-divider></mat-divider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
